import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private injector: Injector,
    private _router: Router,
    private _authService: AuthService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError((httpErrorResponse: HttpErrorResponse) => {
        console.log('ERRROR');
        if (httpErrorResponse.status === 401) {
          console.log('Ddddddd');
          // Sign out
          this._authService.signOut();

          this._router.navigate(['/sign-out']).then(r => {});
        }
        return throwError(httpErrorResponse);
      })
    );
  }
}
